import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "A for loop is not a for loop is not a for loop",
  "description": "",
  "published": "2011-10-19T00:00:00.000Z",
  "redirect_from": ["/blog/a-for-loop-is-not-a-for-loop-is-not-a-for-loop/swizec/2667"],
  "categories": "Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/10/6260572607_be8dca7de4_m2.jpg",
        "alt": "IMG_1675",
        "title": "IMG_1675"
      }}></img></p>
    <p>{`For loops are kind of a big deal.`}</p>
    <p>{`So big in fact that it's virtually impossible to code any sizeable chunk of code without running into some sort of `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/For_loop",
        "title": "For loop"
      }}>{`for loop`}</a>{` ... sure, there's such awesome things as pure `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Functional_programming",
        "title": "Functional programming"
      }}>{`functional languages`}</a>{` where for loops don't look like for loops. But I'm fairly certain most of those eventually turn into some sort of for loop deep down in the bowels of assembler and machine code.`}</p>
    <p>{`It is therefore fairly easy to assert that everyone needs to know for loops like the back of their hand. But how well do you really know them?`}</p>
    <p>{`A few days ago I ran into a silly thing with a couple of friends. We somehow got reminded that C counts the head of a for loop as part of the loop's scope, which means variables defined therein don't really affect anyone outside the loop. But at the same time, it seems like many (most?) other languages don't behave like this.`}</p>
    <p>{`It seemed only reasonable to go write a for loop in many languages and see what happens.`}</p>
    {
      /*more*/
    }
    <h2 {...{
      "id": "c"
    }}>{`C`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-C"
      }}>{`#include<stdio class="h">

int main() {
  int i = 5;

  for (int i=0; i<2; i++) {
    printf("%d\\n", i); // prints 0, 1
  }

  printf("%d\\n", i); // prints 5
}
</stdio>
`}</code></pre>
    <h2 {...{
      "id": "php"
    }}>{`PHP`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-php"
      }}>{`<!--?php<p-->

$i = 5;

for ($i=0; $i<2; $i++) {
  echo "for:$i\\n"; // prints 0, 1
}

echo "after:$i\\n"; // prints 2

$i = 5;

for ($j=0; $j<2; $j++) {
  $i = $j+1;
  echo "for:$i\\n"; // prints 1, 2
}

echo "after:$i\\n"; // prints 2

?>
`}</code></pre>
    <h2 {...{
      "id": "java"
    }}>{`Java`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`// does not compile

public class For {
    public static void main(String[] args) {
        int i = 5;

        for (int i; i<2; i++) {
            System.out.println("for:"+i);
        }

        System.out.println("after:"+i);
    }
}
`}</code></pre>
    <h2 {...{
      "id": "scala"
    }}>{`Scala`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-scala"
      }}>{`object forVarReuse extends App {
       var i=5;

       for (i<-1 to 2) {
           println("for:"+i); // prints 1, 2
       }

       println("after:"+i); // prints 5
}
`}</code></pre>
    <h2 {...{
      "id": "perl"
    }}>{`Perl`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-perl"
      }}>{`$i = 5;

for (local $i=0; $i<2; $i++) {
  print "for:$i\\n"; # prints 0, 1
}

print "after:$i\\n"; # prints 2

$i = 5;

for ($j=0; $j<2; $j++) {
  local $i = $j+1;
  print "for2:$i\\n"; # prints 1, 2
}

print "after:$i\\n"; # prints 5
`}</code></pre>
    <h2 {...{
      "id": "ruby"
    }}>{`Ruby`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-ruby"
      }}>{`i = 5

for $i in 1..2
  print "for:", $i, "\\n" # prints 1, 2
end

print "after:", i, "\\n" # prints 5
`}</code></pre>
    <h2 {...{
      "id": "javascript"
    }}>{`JavaScript`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`var i = 5;

for (var i = 0; i < 2; i++) {
  console.log("for:" + i); // prints 0, 1
}

console.log("after:" + i); // prints 2

i = 5;

for (var j = 0; j < 2; j++) {
  var i = j + 1;
  console.log("for2:" + i); // prints 1, 2
}

console.log("after:" + i); // prints 2
`}</code></pre>
    <h2 {...{
      "id": "coffeescript"
    }}>{`CoffeeScript`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-coffeescript"
      }}>{`i = 5

console.log i for i in [0,1] # prints 0, 1

console.log i # prints 1

i = 5

count = (i for i in [0,1])

console.log count # prints [ 0, 1 ]

console.log i # prints 1
`}</code></pre>
    <h2 {...{
      "id": "python"
    }}>{`Python`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-python"
      }}>{`i = 5

for i in range(2):
    print "for:", i

print "after:", i

i = 5

print [i for i in range(2)] # prints [0, 1]

print "after:", i
`}</code></pre>
    <h2 {...{
      "id": "conclusion"
    }}>{`Conclusion`}</h2>
    <p>{`The interesting part is how differently languages of the curly-braces family behave. Some consider the for loop its own scope, many don't. It's interesting to compare JavaScript and Perl. They both have a way to tell a variable to be defined in the local scope, but JavaScript simply doesn't let you do that with fors, apparently only functions have scope of their own.`}</p>
    <p>{`Ruby is similar to Perl in this regard. That little dollar sign can change the scope and that's what let us pull off the trick since loops are important enough to warrant scope at all.`}</p>
    <p>{`The biggest disappointment is Python. I was honestly expecting the `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/List_comprehension",
        "title": "List comprehension"
      }}>{`list comprehension`}</a>{` to have its own scope, but alas.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://eli.thegreenplace.net/2011/10/19/perls-guess-if-file-is-text-or-binary-implemented-in-python/"
        }}>{`Eli Bendersky: Perl's "guess if file is text or binary" implemented in Python`}</a>{` (eli.thegreenplace.net)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://r.zemanta.com/?u=http%3A//www.infoworld.com/t/javascript/turn-your-nose-dart-and-instead-smell-the-coffeescript-176361&a=58844108&rid=eb2fce30-bdf3-42c1-b2c4-99be7c2b2888&e=592da843a0319c02f51fddfdf273c138"
        }}>{`Turn your nose up at Dart and instead smell the CoffeeScript`}</a>{` (infoworld.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://robots.thoughtbot.com/post/9251081564/coffeescript-spartan-javascript"
        }}>{`This is CoffeeScript`}</a>{` (robots.thoughtbot.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://arstechnica.com/business/news/2011/10/javascript-has-problems-can-googles-dart-solve-them.ars"
        }}>{`Feature: JavaScript has problems. Do we need Dart to solve them?`}</a>{` (arstechnica.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://dartinside.com/2011/dart-bashing/"
        }}>{`Dart Bashing`}</a>{` (dartinside.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://hyperpolyglot.org/scripting"
        }}>{`Hyperpolyglot: PHP, Perl, Python, Ruby`}</a>{` (hyperpolyglot.org)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://blog.izs.me/post/10213512387/javascript-is-not-web-assembly"
        }}>{`JavaScript is Not Web Assembly`}</a>{` (izs.me)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=eb2fce30-bdf3-42c1-b2c4-99be7c2b2888",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      